import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import { Helmet } from "react-helmet";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import EventsContent from "./EventsContent";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";

import { translate, getLanguage } from "../../Translation/Translation";

const styles = {
  paragraph: {
    lineHeight: "48px",
    color: "#293f54",
    fontSize: 28,
    padding: "20px 0px",
  },
};

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itineraries: null,
    };
  }

  render() {
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Local Events | Openseas</title>
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row>
            <div className="OSPageContainer">
              <div className="OSPageContent">
                <p style={styles.paragraph}>
                  {translate(
                    getLanguage(),
                    "Learn about events, concerts, theatrical performances, local traditional festivals, festivals, children's activities at the destination of your choice."
                  )}
                </p>
                <EventsContent
                  itineraries={this.state.itineraries}
                  language={getLanguage()}
                />
                <Row
                  className="BannerRectangleLarge"
                  style={{ margin: "40px 0 20px 0", textAlign: "center" }}
                >
                  <BannerRectangleLarge />
                </Row>
              </div>
              <div className="OSPageSidebar">
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row>
            <Col xs={12}>
              <Footer />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/Pages/Events/Events.js